import React, { createContext, useState, useEffect, ReactNode } from 'react';
import { getSessionStatus, logout } from '../services/api';

interface SessionContextType {
  validated: boolean;
  geoValidated: boolean;
  houseId: string | null;
  setValidated: (value: boolean) => void;
  setGeoValidated: (value: boolean) => void;
  setHouseId: (value: string | null) => void;
  clearSession: () => void;
}

export const SessionContext = createContext<SessionContextType>({
  validated: false,
  geoValidated: false,
  houseId: null,
  setValidated: () => {},
  setGeoValidated: () => {},
  setHouseId: () => {},
  clearSession: () => {},
});

interface SessionProviderProps {
  children: ReactNode;
}

export const SessionProvider: React.FC<SessionProviderProps> = ({ children }) => {
  const [validated, setValidated] = useState<boolean>(false);
  const [geoValidated, setGeoValidated] = useState<boolean>(false);
  const [houseId, setHouseId] = useState<string | null>(null);

  useEffect(() => {
    // Verificar el estado de la sesión al cargar la aplicación
    const checkSession = async () => {
      try {
        const sessionData = await getSessionStatus();
        setValidated(sessionData.validated);
        setGeoValidated(sessionData.geoValidated);
        setHouseId(sessionData.houseId);
      } catch (error) {
        console.error('Error al verificar la sesión:', error);
      }
    };

    checkSession();
  }, []);

  const clearSession = async () => {
    try {
      await logout();
      setValidated(false);
      setGeoValidated(false);
      setHouseId(null);
    } catch (error) {
      console.error('Error al cerrar sesión:', error);
    }
  };

  return (
    <SessionContext.Provider
      value={{
        validated,
        geoValidated,
        houseId,
        setValidated,
        setGeoValidated,
        setHouseId,
        clearSession,
      }}
    >
      {children}
    </SessionContext.Provider>
  );
};
